<template>
<q-page class="main">
  <q-card class="page-card">
    <q-card-section class="page-card__main-content">
      <h1 class="heading-2 q-mb-lg">Inrichtingselementen
      </h1>
      <q-list bordered separator class="rounded-borders">
        <q-item v-for="object in allObjects.data" :key="object.id">
          <q-item-section>
            <div v-if="$isMobile" class="row items-center">
              <div class="col">
                <common-link :label="object.title"
                             :href="$route('object.show', {object: object.id})" />
              </div>
              <div class="col-shrink">
                <icon-button v-if="object.projects.length > 0"
                             color="warning"
                             icon="horizontal_rule"
                             aria-label="Verwijder"
                             @click="removeObject(object.id)"
                />
                <icon-button v-else aria-label="Toevoegen" icon="add" @click="addObject(object.id)" />
              </div>
            </div>
            <div v-else class="row items-center q-col-gutter-x-md">
              <div class="col-sm-3 col-md-3">
                <common-link :label="object.title"
                             :href="$route('object.show', {object: object.id})" />
              </div>
              <div class="col-sm-3 col-md-5">
                {{ object.type }}
              </div>
              <div class="col-sm-3 col-md-2">
                {{ object.group.title }}
              </div>
              <div class="col-sm-3 col-md-2 text-right">
                <primary-button v-if="object.projects.length > 0"
                                color="warning"
                                icon="horizontal_rule"
                                label="Verwijder"
                                @click="removeObject(object.id)" />
                <primary-button v-else label="Toevoegen" icon="add" @click="addObject(object.id)" />
              </div>
            </div>
          </q-item-section>
        </q-item>
      </q-list>
      <div v-if="allObjects.last_page > 1" class="flex flex-center q-pa-md">
        <pagination-links :items="allObjects" />
      </div>
    </q-card-section>
  </q-card>
  <sticky-top-bar />
</q-page>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
    },
    projectTitle: {
      type: String,
      default: "",
    },
    categories: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
    allObjects: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    removeObject (objectId) {
      this.$goto("project.object.remove", { project_id: this.project.id, object_id: objectId })
    },
    addObject (objectId) {
      this.$goto("project.object.add", { project_id: this.project.id, object_id: objectId })
    },
  },
}
</script>
